import {combineReducers} from "redux";

import coursesListReducer from "./coursesList";


export default combineReducers({
    coursesList : coursesListReducer,
});